"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PowerActionType;
(function (PowerActionType) {
    PowerActionType["APP_RESTART"] = "APP_RESTART";
    PowerActionType["SYSTEM_REBOOT"] = "SYSTEM_REBOOT";
    PowerActionType["APPLET_RELOAD"] = "APPLET_RELOAD";
    PowerActionType["APPLET_REFRESH"] = "APPLET_REFRESH";
    PowerActionType["DISPLAY_POWER_ON"] = "DISPLAY_POWER_ON";
    PowerActionType["DISPLAY_POWER_OFF"] = "DISPLAY_POWER_OFF";
    PowerActionType["BACKUP_RESTART"] = "BACKUP_RESTART";
    PowerActionType["APPLET_ENABLE"] = "APPLET_ENABLE";
    PowerActionType["APPLET_DISABLE"] = "APPLET_DISABLE";
    PowerActionType["FILE_SYSTEM_WIPEOUT"] = "FILE_SYSTEM_WIPEOUT";
    PowerActionType["REAPPLY_POLICY"] = "REAPPLY_POLICY";
})(PowerActionType || (PowerActionType = {}));
exports.default = PowerActionType;
